@if (content) {
    <div class="text">
        @if (content.headline) {
            <h2 class="typo-ws-h2">{{ content.headline }}</h2>
        }
        @if (content.src) {
            <blog-picture [picture]="content" [noCaption]="true"></blog-picture>
        }
        <sew-markdown ws [markdown]="text | replaceLinebreak"></sew-markdown>
    </div>
}
